module.exports = JSON.parse('{"Studies":"Études","Measurements":"Mesures","Measure":"Mesurer","Segmentation":"Segmentation"}')